export type DiagnosticUser = {
  id: number;
  email: string;
  firstName: string;
  lastName: string;
  fullName: string;
  hasPatientProfile: boolean;
  patientProfileGender: string | null;
  createdAt: string;
  updatedAt: string;
};

const url = "/api/v1/diagnostics/current_user";

export interface DiagnosticUserIndexResponse {
  data: {
    type: "diagnostic_user";
    id: string;
    attributes: DiagnosticUser;
  };
}

export const diagnosticUserIndexQuery = () => ({
  url,
  method: "GET" as const,
});